import { ColorPalette } from 'types/muiTheme'

export const lightTheme: ColorPalette = {
  mode: 'light',
  primary: {
    main: '#3091d1',
  },
  text: {
    primary: '#242829',
    dim: 'rgba(36, 40, 41, 0.78)',
    secondary: '#4c4e52',
    disabled: '#9e9e9e',
  },
  secondary: {
    main: '#66C2C4',
  },
  common: {
    white: '#FFFFFF',
  },
  action: {
    hover: 'rgba(0, 0, 0, 0.12)',
    focus: 'rgba(0, 0, 0, 0.12)',
  },
  shadows: {
    0: 'none',
    1: '0 0px 6px rgba(0, 0, 0, 0.1)',
  },
  background: {
    default: '#F7F7F8',
    paper: '#FDFDFD',
  },
  divider: '#D8D8D8',
  custom: {
    sidebar: {
      backgroundColor: '#111729',
      textDimColor: 'rgba(255, 255, 255, 0.7)',
      color: '#F0F0F4',
      iconBackground: 'rgba(0, 0, 0, 0.5)',
      avatarBgColor: '#027FC2',
    },
    link: {
      color: '#1b5aa6',
    },
    button: {
      primaryText: '#F5F5F5',
      primaryTextHover: '#231F20',
      primaryBackground: '#262839',
      focusedOutline: '#78D1C8',
    },
    input: {
      backgroundColor: '#FDFDFD',
      border: '1px solid #D2D2D2',
    },
    widgetToolbar: {
      backgroundColor: '#FDFDFD',
      boxShadow: '0 0px 6px rgba(0, 0, 0, 0.1)',
    },
    widget: {
      headerColor: '#EFEFEF',
      backgroundColor: '#FDFDFD',
      border: '1px solid #D2D2D2',
    },
    widgetButton: {
      backgroundColor: '#EFEFEF',
      boxShadow: '0 0px 6px rgba(0, 0, 0, 0.1)',
      hoverBackgroundColor: '#CFCFCF',
      border: '1px solid #D2D2D2',
    },
    subscription: {
      borderColor: '#F6B900',
    },
    widgetDropTarget: {
      backgroundColor: 'rgba(102, 194, 196, 0.5)',
      border: '2px solid #66C2C4',
    },
    mosaicWindowToolbar: {
      backgroundColor: '#EFEFEF',
      boxShadow: '0 0px 4px rgba(0, 0, 0, 0.05)',
    },
    gridTable: {
      background: '#FDFDFD',
      columnHeaderBackground: '#F1F3F9',
      borderColor: '#DEE2EC',
      textHighlight: '#0c64c4',
    },
  },
}
